import { useDispatch, useSelector } from '@redux';
import { Button, Modal, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import PrintLabel from './PrintLabel';
import crudActions from '@redux/crudActions';
import crudSelectors from '@redux/crudSelectors';
import { DynamicObjectType } from 'core/types/common';
import { useTranslation } from 'react-i18next';
import PrintLabelModal from './Modal/PrintLabel';
import { getBatchLabelApi } from 'api/orders';

const ButtonPrintLabel = ({
  batchId,
  isShowByUrl,
  isMarketPlace,
  count,
}: {
  batchId?: string;
  isShowByUrl?: boolean;
  isMarketPlace?: boolean;
  count?: number;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedRowKeys = useSelector<any[]>(
    (state) => state.orderBatches.selectedRowKeys,
  );
  const orders = useSelector((state) => state.ordersDetail.data);
  const listOrders = useSelector<DynamicObjectType>(
    crudSelectors.ordersDetail.getDataRecordArr,
  );
  const [visible, setVisible] = useState(false);
  const [noticeModal, setNoticeModal] = useState(false);
  const mappingSelectedRowKeys = listOrders?.map((order) => order?.id);

  useEffect(() => {
    if (visible && (batchId || selectedRowKeys?.length > 0)) {
      dispatch(
        crudActions.ordersDetail.getAll({
          data: {
            join: [],
            filters: [
              {
                condition: 'and',
                key: 'orderBatchId',
                value: batchId || selectedRowKeys,
                operator: 'is',
              },
            ],
            page: 1,
            pageSize: count || 99,
          },
          options: {
            isRefresh: true,
          },
        }),
      );
    }
  }, [selectedRowKeys, visible, batchId]);

  const handlePrintBatch = () => {
    setNoticeModal(true);
    getBatchLabelApi(batchId).then((res: { url?: string; error?: string }) => {
      console.log(res);
      if (res?.url) {
        window.open(res?.url || '', '__blank');
      }

      setNoticeModal(false);
      if (res.error) {
        notification.error({
          message: 'Generate Label Failure.',
        });
      }
    });
  };

  return (
    <>
      <Button
        type="primary"
        className="h-10"
        onClick={() =>
          batchId && isMarketPlace ? handlePrintBatch() : setVisible(true)
        }
        disabled={!selectedRowKeys?.length && !batchId}
      >
        {t('common.button.printLabel')}
      </Button>
      {isShowByUrl ? (
        <PrintLabelModal visible={visible} setVisible={setVisible} />
      ) : (
        <PrintLabel
          selectedRowKeys={mappingSelectedRowKeys}
          visible={visible}
          setVisible={setVisible}
          initPrintType="printLabelBig"
          orders={orders}
          printActions={['printLabelBig', 'printLabelSmall']}
        />
      )}
      {noticeModal && (
        <Modal closable={false} footer={null} open={true}>
          {t('orderPrint.batchLabelNotice')}
        </Modal>
      )}
    </>
  );
};

export default ButtonPrintLabel;
